import React, { type ReactNode, type ComponentProps } from 'react';

import { AnimatePresence as FramerMotionAnimatePresence } from 'framer-motion';

type AnimatePresenceProps = ComponentProps<
  typeof FramerMotionAnimatePresence
> & {
  children: ReactNode;
};

const AnimatePresence = (props: AnimatePresenceProps) => {
  return <FramerMotionAnimatePresence {...props} />;
};

AnimatePresence.displayName = 'AnimatePresence';

export default AnimatePresence;
